import { render, staticRenderFns } from "./testimonials.vue?vue&type=template&id=7f759d52&scoped=true"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"
import style0 from "./testimonials.vue?vue&type=style&index=0&id=7f759d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f759d52",
  null
  
)

export default component.exports